import { useState, useEffect } from 'react'

export default width => {
  const [targetReached, setTargetReached] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${width}px)`)
    media.addEventListener('change', e => setTargetReached(!!e.matches))

    // Check on mount (callback is not called until a change occurs)
    if (media.matches) {
      setTargetReached(true)
    }

    return () => media.removeEventListener('change', e => setTargetReached(!!e.matches))
  }, [])

  return targetReached
}
